import type { ListData, ListItem, ListMetadata } from "../list.type";
import type {
  FormatListDataProps,
  GetListMetadataProps,
} from "./list-fetcher.type";

import pick from "lodash/pick";

import { getApiPaginationTotal } from "@/services/api";

export const formatListData = <
  DataItem extends ListItem = ListItem,
  Metadata = unknown,
>({
  data,
  withMetadata,
  isLoading,
  isFetching,
}: FormatListDataProps<DataItem>): ListData<DataItem, Metadata> => ({
  data: data?.data ?? [],
  total: getApiPaginationTotal(data),
  metadata: getListMetadata<DataItem, Metadata>({ data, withMetadata }),
  loading: isLoading,
  fetching: isFetching,
});

export const getListMetadata = <
  DataItem extends ListItem = ListItem,
  Metadata = unknown,
>({
  data,
  withMetadata,
}: GetListMetadataProps<DataItem>): ListMetadata<Metadata> => {
  if (!data || !withMetadata) return {};

  return pick(data, withMetadata) as ListMetadata<Metadata>;
};
